import React, { useEffect, useRef, useState } from "react";
import "ol/ol.css";
import "ol-layerswitcher/dist/ol-layerswitcher.css";
import './App.css';
import Index from "../../components/home";
import ReactDOM from "react-dom";
import Country_year_selection from "../../components/country_year_selection";
import Basin_selection from "../../components/basin_selection";
import logo from '../../assets/logo.jpg'
import Region_selection from "../../components/region_selection";
import EtChart from "../../components/et_chart";
import BasinChart from "../../components/basin_chart";


function HomeIndex() {
  const [selectedRegion, setSelectedRegion] = useState("Map View -- Grace 2024");
  const mapRef = useRef(null);  
  const handleYearChange1 = (value) => {
    setSelectedRegion('Map View -- '+ value);
    let componentToRender;
    switch (value) {
      case "Annual":
        componentToRender = <Country_year_selection />;
        break;
      case "Basin":
          componentToRender = <Basin_selection />;
        break;
      case "Region":
          componentToRender = <Region_selection />;
        break;
      case "Et_chart":
          componentToRender = <EtChart />;
        break;
      case "Basin_chart":
          componentToRender = <BasinChart />;
        break;
          
      default:
        componentToRender = null;
        break;
    }
    ReactDOM.render(componentToRender, document.getElementById("container_Annual_Selection1"));
  };

  return (
    <>
      <div className="row">
        <div className="col-lg-3 home_sidebare">
          <div className='sidebar_container'>
              <img src={logo} alt="Logo" />             
          </div>          
          <div className="sideTitle">
            <h4>GRACE(-FO) Data Water Equivalent Thickness</h4>
            <h4>2002 - 2024</h4>
          </div>    
          <div className="sideTitle1">
            <p>Available Data</p>
          </div>       
          <div className="availableData">
            <a onClick={() => handleYearChange1('Annual')} >Ethiopia</a>&nbsp;
            <a onClick={() => handleYearChange1('Region')} >Region</a>
            <a onClick={() => handleYearChange1('Basin')} >Basin</a>&nbsp;&nbsp;
          </div>
          <div className="sideTitle1">
            <p >Analysis/Chart</p>
          </div> 
          <div className="availableData">

          </div>    
          <div className="availableData">
          <a onClick={() => handleYearChange1('Et_chart')} >Ethiopia</a>
          <a onClick={() => handleYearChange1('Basin_chart')} >Basin</a>&nbsp;&nbsp;
          </div>
        </div>        
        <div id='container_map' className="col-lg-9">
          <div id='container_Annual_Selection1'style={{ height: "100vh" }}>
            <Index/>
          </div>         
        </div>
      </div>
    </>
  );
}

export default HomeIndex;
